// PIN rules the processor enforces that can be checked before sending.
//
// E6 refuses a PIN that is one digit four times (0000-9999), the card's last four
// digits, or anything drawn from the cardholder's date of birth, phone numbers or
// external references. Only the first two are knowable here without pulling
// personal details into the form, so the rest stay with E6, and the screens list
// them so a refusal is not a surprise.

export const PIN_LENGTH = 4;

// A PIN field holds digits only: anything else is dropped and entry stops at four.
export const toPinEntry = value =>
  value.replace(/\D/g, '').slice(0, PIN_LENGTH);

// 'repeated' | 'card-digits' | null
export const pinRuleViolation = (pin, lastFourDigits) => {
  if (/^(\d)\1{3}$/.test(pin)) return 'repeated';
  if (lastFourDigits && pin === lastFourDigits) return 'card-digits';
  return null;
};
